import { GetterTree } from "vuex";
import { RootState } from "../../types";
import { UserState } from "./types";
import { CurrentUser } from "../friends/types";

const getUserId = "getUserId";
const getCurrentUser = "getCurrentUser";
const getAvatarId = "getAvatarId";
const n = {
  getUserId,
  getCurrentUser,
  getAvatarId,
};

export const getters: GetterTree<UserState, RootState> = {
  [n.getUserId](state): null | string {
    return state.user?.uid ?? null;
  },
  [n.getCurrentUser](state): null | CurrentUser {
    const user = state.user;

    if (user) {
      const avatarId = user.photoURL ?? "000";
      console.log("getCurrentUser", avatarId);

      return {
        displayName: user.displayName ?? " - ",
        avatarId: avatarId.substr(avatarId.length - 3),
        id: user.uid,
        email: user.email ?? "",
      };
    } else {
      return null;
    }
  },
  [n.getAvatarId](state) {
    const user = state.user;

    const avatarId = user?.photoURL ?? "000";
    return avatarId.substr(avatarId.length - 3);
  },
};

export const getterNames = n;
